// Traduction des messages d'erreur de l'API en français
export const translateErrorMessage = (errorMessage) => {
  // Messages d'erreur courants de l'API
  // IMPORTANT: Mettre les messages spécifiques AVANT les génériques
  const translations = {
    // Erreurs de validation email spécifiques
    'value is not a valid email address: An email address cannot have a period immediately before the @-sign.': 'L\'adresse email ne peut pas avoir un point juste avant le @',
    'value is not a valid email address: An email address cannot have two periods in a row.': 'L\'adresse email ne peut pas avoir deux points consécutifs',
    'value is not a valid email address: An email address cannot start with a period.': 'L\'adresse email ne peut pas commencer par un point',
    'An email address cannot have a period immediately before the @-sign': 'L\'adresse email ne peut pas avoir un point juste avant le @',
    'An email address cannot have two periods in a row': 'L\'adresse email ne peut pas avoir deux points consécutifs',
    'An email address cannot start with a period': 'L\'adresse email ne peut pas commencer par un point',
    
    // Erreurs de validation email génériques (après les spécifiques)
    'value is not a valid email address': 'Adresse email invalide',
    
    // Erreurs d'inscription
    'Email already registered': 'Cette adresse email est déjà utilisée',
    'Passwords do not match': 'Les mots de passe ne correspondent pas',
    
    // Erreurs de connexion
    'Incorrect email or password': 'Email ou mot de passe incorrect',
    'Incorrect username or password': 'Email ou mot de passe incorrect',
    
    // Erreurs génériques
    'User not found': 'Utilisateur non trouvé',
    'Access denied': 'Accès refusé',
    'Unauthorized': 'Non autorisé',
    'Forbidden': 'Accès interdit',
    'Internal server error': 'Erreur interne du serveur',
    
    // Erreurs de validation de mot de passe
    'Password too short': 'Mot de passe trop court',
    'Password must contain': 'Le mot de passe doit contenir',
    
    // Erreurs réseau
    'Network error': 'Erreur réseau',
    'Connection failed': 'Échec de la connexion',
    'Timeout': 'Délai d\'attente dépassé'
  };
  
  // Chercher une traduction exacte d'abord
  if (translations[errorMessage]) {
    return translations[errorMessage];
  }
  
  // Trier les clés par longueur décroissante pour traiter les messages les plus spécifiques en premier
  const sortedKeys = Object.keys(translations).sort((a, b) => b.length - a.length);
  
  // Chercher des correspondances partielles en commençant par les plus spécifiques
  for (const englishError of sortedKeys) {
    if (errorMessage.toLowerCase().includes(englishError.toLowerCase())) {
      return translations[englishError];
    }
  }
  
  // Si aucune traduction trouvée, retourner le message original
  return errorMessage;
}; 